// extracted by mini-css-extract-plugin
export default {"container":"OrderItemsWithPriceChanges_container__StEVj","table":"OrderItemsWithPriceChanges_table__5Fj1b"};